const IOS_APP_ID_PATTERN = /^\d{6,20}$/;
const ANDROID_PACKAGE_NAME_PATTERN = /^[a-zA-Z0-9_]+\.[a-zA-Z0-9_.]+$/;

function trimAppId(appIdRaw: string | undefined | null): string {
	return String(appIdRaw ?? "").trim();
}

// Перевірка формату App ID для обраного магазину (як на бекенді для iOS / Android).
export function isAppIdAcceptableForSubmit(
	appIdRaw: string | undefined | null,
	appStore: string | undefined | null,
): boolean {
	const appId = trimAppId(appIdRaw);
	const store = appStore ?? "";
	if (!appId) return false;
	if (store === "APPLE_APP_STORE") return IOS_APP_ID_PATTERN.test(appId);
	if (store === "GOOGLE_APP_STORE")
		return ANDROID_PACKAGE_NAME_PATTERN.test(appId);
	return false;
}

// Показ помилки формату під полем app_store лише для непорожнього app_id і відповідної платформи.
export function getAppIdFormatIssue(
	appIdRaw: string | undefined | null,
	appStore: string | undefined | null,
): "ios" | "android" | null {
	const appId = trimAppId(appIdRaw);
	const store = appStore ?? "";
	if (!appId) return null;
	if (store === "APPLE_APP_STORE" && !IOS_APP_ID_PATTERN.test(appId))
		return "ios";
	if (store === "GOOGLE_APP_STORE" && !ANDROID_PACKAGE_NAME_PATTERN.test(appId))
		return "android";
	return null;
}
